"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onCreate: function() {
          this.state = {
              feedTarget: false
            };
        },
        onFeedHelp: function(target) {
          this.state.feedTarget = target;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Wrapper-Admin.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Header_Admin_template = require("./Header-Admin.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Header_Admin_tag = marko_loadTag(Header_Admin_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    Footer_Admin_template = require("./Footer-Admin.marko"),
    Footer_Admin_tag = marko_loadTag(Footer_Admin_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    FeedHelp_template = require("./FeedHelp/index.marko"),
    FeedHelp_tag = marko_loadTag(FeedHelp_template),
    Wrapper_template = require("../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template);

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "overflow-hidden",
      renderBody: function(out, wscope) {
        AutoScroll_tag({
            height: "100vh",
            style: "padding-bottom:40px",
            renderBody: function(out) {
              Header_Admin_tag({
                  title: input.title,
                  nobreadcrump: input.nobreadcrump
                }, out, __component, "2");

              out.be("section", {
                  "class": marko_classValue(marko_classValue([
                    "px-md-5 px-4 pt-2 animated fadeIn",
                    input.class
                  ]))
                }, "3", component, null, 1);

              marko_dynamicTag(out, input.renderBody, function() {
                return wscope;
              }, null, null, null, __component, "4");

              out.ee();
            }
          }, out, __component, "1");

        Footer_Admin_tag({}, out, __component, "5", [
          [
            "help",
            "onFeedHelp",
            false
          ],
          [
            "feedback",
            "onFeedHelp",
            false
          ]
        ]);

        FeedHelp_tag(marko_assign({
            target: state.feedTarget
          }, wscope), out, __component, "6", [
          [
            "dismiss",
            "onFeedHelp",
            false,
            [
                false
              ]
          ]
        ]);
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
